<script setup lang="ts">
  import { marked } from 'marked'
  import { isInlineModal } from '@/utils/inlineModalHelpers'

  const props = defineProps<{ blok: any }>()

  const output = computed(() => marked(props.blok.content))

  const isModalVisible = ref(false)

  const handleClick = (e: MouseEvent) => {
    if (!isInlineModal(e.target as HTMLElement)) {
      return
    }

    isModalVisible.value = true
  }
</script>

<template>
  <div>
    <LazyUiModalSb
      v-if="isModalVisible && !!blok.modalData"
      v-model="isModalVisible"
      :blok="blok.modalData"
    />
    <div
      class="mt-6 only:[&_*]:m-0 [&_a]:text-inherit"
      @click="handleClick"
      v-html="output"
    />
  </div>
</template>
